import React, { useEffect, useState } from 'react';
import { useForm, Controller } from "react-hook-form";
import { Container, Typography, InputLabel, Paper, Divider, Button, Grid, CircularProgress } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import { MerchantActions, NotificationActions } from '../../../store';
import MerchantStepOne from './MerchantStepOne';
import MerchantStepTwo from './MerchantStepTwo';
import MerchantStepThree from './MerchantStepThree';
import MerchantStepFour from './MerchantStepFour';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px'
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})


const merchantsSelector = (state) => state.Merchants;
const IdentitySelector = (state) => state.Identity;



const MerchantRegistrationUpdate = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const merchantActions = bindActionCreators(MerchantActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { editing, nowWainting } = useSelector(merchantsSelector);
    const { token } = useSelector(IdentitySelector);

    const { control, errors, handleSubmit, watch, register } = useForm();

    const { classes } = props;
  
    const handleBack = (data) => {
        // 対象の加盟店IDの加盟店情報を取得
        merchantActions.loadEditModel(token, editing.id)
            .then(data => {
                props.onCancel();
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    };

    const handleUpdate = (data) => {
        // 加盟店情報を更新
        merchantActions.update(token, editing)
            .then(data => {
                props.onUpdate();
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    };

    const getStepContent = (index) => {
        switch (index) {
            case '0':
                return <MerchantStepOne onChange={onChange} handleBack={handleBack} handleNext={handleUpdate} mode="update" />
            case '1':
                return <MerchantStepTwo onChange={onChange} handleBack={handleBack} handleNext={handleUpdate} mode="update" />
            case '2':
                return <MerchantStepThree onChange={onChange} handleBack={handleBack} handleNext={handleUpdate} mode="update" />
            case '3':
                return <MerchantStepFour onChange={onChange} handleBack={handleBack} handleNext={handleUpdate} mode="update" />
            default:
                return 'Unknown stepIndex';
        }
    }

    const getTitle = (index) => {
        switch (index) {
            case '0':
                return <FormattedMessage id="Merchant.StepOne" />
            case '1':
                return <FormattedMessage id="Merchant.StepTwo" />
            case '2':
                return <FormattedMessage id="Merchant.StepThree" />
            case '3':
                return <FormattedMessage id="Merchant.StepFour" />
            default:
                return 'Unknown Title';
        }
    }

    const onChange = (e) => {
        const currentState = editing;
        const { name, value } = e[0].target;
        currentState[name] = value;
        return value;
    }

       
    return (
        <Container className={classes.root} maxWidth={false}>
            <Paper className={classes.paper}>
                <Grid container className={classes.form} spacing={2}>
                    <Grid item xs={12}>
                        <Typography component="h1" variant="inherit">{getTitle(props.intIndex)}</Typography>
                        <Divider />
                    </Grid>
                    <Grid item xs={12}>
                        <InputLabel component="legend">{<FormattedMessage id="Merchant.HelperUpdateText" />}</InputLabel>
                    </Grid>
                </Grid>
                {getStepContent(props.intIndex)}
            </Paper>
            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(MerchantRegistrationUpdate);
